import { topOpportunityMaxWidth } from "@/components/pages/common/opportunities/utils/constants/common";

export const getTopOpportunitiesFittingCount = (width?: number) =>
  width
    ? Math.floor((width - paddings) / topOpportunityMaxWidth - 1)
    : undefined;

const paddings = 24;
